declare global {
  interface Window {
    ym: any;
  }
}

export const ymGoal = (goal: string) => {
  window.ym(68874502, 'reachGoal', goal);
  return true;
};

export const addYmGoalListeners = () => {
  const listeners = ['regFinished', 'authFinished', 'clickEnterHeader', 'clickRestore', 'livePageOpen', 'regPageOpen', 'staticPageOpen', 'clickLiveHeader'];

  // eslint-disable-next-line
  listeners.map((listener: string): void => {
    (window as { [key: string]: any })[listener] = new Event(listener);

    window.addEventListener(listener, function(e) {
      console.log('EVENT DISPATCHED', e.type);
      window.ym(68874502, 'reachGoal', e.type);
    }, false);
  });
};
